// extracted by mini-css-extract-plugin
export default {"loaderContainer":"popup_loaderContainer__Sg5K2"};